import { DeleteOutlined,EditOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Typography,
} from "antd";
import { UserApiService } from "features/users/api/user-api.service";
import { useCreateUserAgentRole } from "features/users/use-cases/create-agent-role";
import { useMemo, useState } from "react";

const { Title } = Typography;

export const AgentSetPermissionList = ({
  itemlist,
  setEditData,
  setModel,
  refetch,
  setprivilegestate,
  SetRoleName,
  setSelectedRoleId,
  selectedRoleId
}: any) => {
  const { mutate, isLoading: deleting } = useCreateUserAgentRole();
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [search, setSearch] = useState("");
  // 🔥 Fetch privilege by role_id
  const handlePrivilegeFetch = async (id: number) => {
    try {
      const res = await UserApiService().getprivilepermissions({ roleId: id,UserType:2 } as any);
      message.success("Privilege loaded!");
      setprivilegestate(res)
    } catch (error: any) {
      message.error("Failed to load privilege.");
    }
  };

  const filteredList = useMemo(() => {
    if (!itemlist?.items) return [];

    return itemlist.items.filter((item: any) =>
      item.role_name.toLowerCase().includes(search.toLowerCase())
    );
  }, [itemlist, search]);

  const handleDelete = (id: number) => {
    setDeleteId(id);
    const payload: any = {
      flag: "delete",
      roleId: id,
    };

    mutate(payload, {
      onSuccess: (data: any) => {
        if (data?.ResponseStatus == 0) {
          message.error(data?.ResponseMessage);
        } else {
          message.success(data?.ResponseMessage)
        }
        setDeleteId(null);
        refetch();
      },
    });
  };

  return (
    <>
      <Form layout="vertical" autoComplete="off">
        {/* 🔎 Search Role */}
        <Form.Item label="Role" name="RoleName">
          <Input
            placeholder="Search role..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Form.Item>

        {/* List of Roles */}
        <div style={{ marginTop: 16 }}>
          {filteredList.map((item: any) => (
            <Row
              key={item.id}
              justify="space-between"
              align="middle"
              style={{
                padding: "10px 0",
                borderBottom: "1px solid #f0f0f0",
                marginBottom: 8,
              }}
            >
              {/* CLICK → API HIT */}
              <Title
                level={5}
                style={{
                  margin: 0,
                  cursor: "pointer",
                  // textDecoration: selectedRoleId === item.id ? "underline" : "none",
                  color:selectedRoleId === item.id ? "#1677ff" : "#000",
                  textUnderlineOffset: 4,
                }}
                onClick={() => { handlePrivilegeFetch(item.id); SetRoleName(item?.role_name); setSelectedRoleId(item.id); }}
              >
                {item.role_name}
              </Title>

              <div style={{ display: "flex", gap: 12 }}>
                {/* ✏ Edit */}
                <EditOutlined
                  style={{
                    color: "#1677ff",
                    cursor: "pointer",
                    fontSize: 16,
                  }}
                  onClick={() => {
                    setEditData(item);
                    setModel(true);
                  }}
                />

                {/* 🗑 Delete */}
                <Popconfirm
                  title="Are you sure you want to delete?"
                  onConfirm={() => handleDelete(item.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteOutlined
                    style={{
                      color: "red",
                      cursor: "pointer",
                      fontSize: 16,
                      opacity: deleting && deleteId === item.role_id ? 0.4 : 1,
                    }}
                  />
                </Popconfirm>
              </div>
            </Row>
          ))}
        </div>
      </Form>
    </>
  );
};
